import { render, staticRenderFns } from "./SidebarToggle.vue?vue&type=template&id=e540a27e&scoped=true"
import script from "./SidebarToggle.vue?vue&type=script&lang=js"
export * from "./SidebarToggle.vue?vue&type=script&lang=js"
import style0 from "./SidebarToggle.vue?vue&type=style&index=0&id=e540a27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e540a27e",
  null
  
)

export default component.exports